<template>
    <div v-if="posts.length>0" class="o-flex -flex-start -flex-gap">
        <div class="o-toggle">
            <div class="o-toggle__input__wrap">
                <input v-model="showAnimations" class="o-toggle__input" type="checkbox" id="vshowAnimation" value="1">
                <div class="o-toggle__toggler"></div>
            </div>
            <label class="o-toggle__label" for="vshowAnimation">
                <span class="o-toggle__label__text">
                    Animations
                </span>
            </label>
        </div>
        <div class="o-toggle">
            <div class="o-toggle__input__wrap">
                <input v-model="showAuteurs" class="o-toggle__input" type="checkbox" id="vshowAuteur" value="1">
                <div class="o-toggle__toggler"></div>
            </div>
            <label class="o-toggle__label" for="vshowAuteur">
                <span class="o-toggle__label__text">
                    Auteur.e.s
                </span>
            </label>
        </div>
    </div>
    <div v-if="posts.length>0" class="c-overlay__notebook__list">
        <template v-for="post in filteredPosts">
            <div class="c-overlay__notebook__list__item">
                <div class="o-flex -flex-middle -flex-space-between -flex-wrap-nowrap">
                    <div class="o-flex -flex-gap-sm -flex-middle ">
                        <div class="o-tag u-color-black">
                            {{ post.dateLabel }}
                        </div>
                        <div>
                            {{ post.heureLabel }}
                        </div>
                        <div v-if="post.lieu !== undefined">
                            <a class="-text-uppercase -text-bold" :href="post.lieu.url">{{ post.lieu.title }}</a>
                        </div>
                    </div>
                    <button @click.prevent="deletePost(post)" class="o-list__result__item__button -flex-shrink-0">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#trash"></use>
                        </svg>
                    </button>
                </div>
                <div class="o-spacer-sm"></div>
                <div v-if="post.jeunesse || post.isHLM || post.isConference || post.isMauricie" class="o-flex -flex-middle -flex-direction-column-under-sm -flex-start-under-sm">
                    <div v-if="post.isJeunesse" class="o-flex -flex-middle -flex-gap-xxs">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#puzzle"></use>
                        </svg>
                        Activité jeunesse
                    </div>
                    <div v-if="post.isHLM" class="o-flex -flex-middle -flex-gap-xxs">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#door"></use>
                        </svg>
                        Activité hors les murs
                    </div>
                    <div v-if="post.isConference" class="o-flex -flex-middle -flex-gap-xxs">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#microphone"></use>
                        </svg>
                        Conférences
                    </div>
                    <div v-if="post.isMauricie" class="o-flex -flex-middle -flex-gap-xxs">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#region"></use>
                        </svg>
                        Auteur.e.s de la région
                    </div>
                    <div v-if="post.isIllustrateur" class="o-flex -flex-middle -flex-gap-xxs">
                        <svg aria-hidden="true" focusable="false" class="o-ico">
                            <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#paint"></use>
                        </svg>
                        Illustrateur.ice.s
                    </div>
                </div>
                <div class="o-spacer"></div>
                <h2 class="o-title-3 -text-no-margin">
                    <a :href="post.url">
                        {{ post.title }}
                    </a>
                </h2>
            </div>
        </template>
        <div v-if="filteredPosts.length==0" class="o-flex -flex-direction-column -flex-center -flex-middle -flex-grow-1 -flex-width-100p">
            <div class="o-spacer"></div>
            <h3 class="o-title-3 -text-sans-serif -text-center">
                Aucun résultat ne correspond <br>à vos filtres.
            </h3>
        </div>
    </div>
    <div v-if="posts.length>0" class="c-overlay__notebook__tools">
        <div class="c-overlay__notebook__tools__left">
            <button v-if="!loggedIn" @click.prevent="$emit('toggleView', 'login')" class="c-overlay__notebook__tools__link">
                Connexion
            </button>
            <button v-if="loggedIn" @click.prevent="$emit('logout')" class="c-overlay__notebook__tools__link">
                Déconnexion
            </button>
            <button v-if="!loggedIn" @click.prevent="$emit('toggleView', 'register')" class="c-overlay__notebook__tools__link">
                S'inscrire
            </button>
        </div>
        <div class="c-overlay__notebook__tools__right">
            <button v.if="posts.length>0" @click.prevent="generateCal()" class="c-overlay__notebook__tools__link">
                Ajouter à mon calendrier
                <svg aria-hidden="true" focusable="false" class="o-ico">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#calendar"></use>
                </svg>
            </button>
            <a href="/carnet-imprime/" target="_blank" class="c-overlay__notebook__tools__link">
                Imprimer
                <svg aria-hidden="true" focusable="false" class="o-ico">
                    <use xlink:href="/app/themes/baserock/assets/img/sprite.svg?v=2024#print"></use>
                </svg>
            </a>
        </div>
    </div>
    <div v-if="posts.length==0" class="o-flex -flex-direction-column -flex-center -flex-middle -flex-grow-1 -flex-width-100p">
        <h3 class="o-title-3 -text-sans-serif -text-center">
            Votre carnet est <br>présentement vide.
        </h3>
        <div class="c-overlay__notebook__tools o-flex -flex-center">
            <div class="c-overlay__notebook__tools__left">
                <button v-if="!loggedIn" @click.prevent="$emit('toggleView', 'login')" class="c-overlay__notebook__tools__link">
                    Connexion
                </button>
                <button v-if="loggedIn" @click.prevent="$emit('logout')" class="c-overlay__notebook__tools__link">
                    Déconnexion
                </button>
                <button v-if="!loggedIn" @click.prevent="$emit('toggleView', 'register')" class="c-overlay__notebook__tools__link">
                    S'inscrire
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { createEvents } from 'ics';

export default {
    name: 'CarnetCart',
    props: {
        posts: {
            type: Array,
            required: true
        },
        loggedIn: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            showAnimations: true,
            showAuteurs: true
        }
    },
    mounted() {
    },
    computed: {
        filteredPosts() {
            return this.posts.filter(this.isVisible);
        }
    },
    methods: {
        isVisible(post) {
            return (this.showAnimations && post.type == 'animations') || (this.showAuteurs && post.type == 'auteurs');
        },
        deletePost(post) {
            this.$emit('deletePost', {id: post.id, date: post.date, heure: post.heure});
        },
        async generateCal() {
            const events = [];

            this.posts.forEach(post => {
                if (post.date == '' || post.heure == '') return;

                let hours = post.heure.split(' à ');
                if (hours[0].indexOf(':') > -1) {
                    hours[0] = hours[0].split(':');
                } else if (hours[0].indexOf('h') > -1) {
                    hours[0] = hours[0].split(' h ');
                }

                // parse integer
                let month = parseInt(post.date.split('/')[0]);
                let day = parseInt(post.date.split('/')[1]);
                let year = parseInt(post.date.split('/')[2]);
                let hour = parseInt(hours[0][0]);
                let minute = parseInt(hours[0][1]);
                // convert hour to ics format
                let hour_ics = hour < 10 ? '0' + hour : hour;
                let minute_ics = minute < 10 ? '0' + minute : minute;
                /// hours are 4 hours earlier than ics format
                //hour_ics = hour_ics - 4;

                let url = post.url;
                //console.log([year, month, day, hour_ics, minute_ics]);
                //return
                events.push({
                    start: [year, month, day,hour_ics, parseInt(minute_ics)],
                    title: post.title,
                    description: post.description,
                    location: post.lieu !== undefined ? post.lieu.title : '',
                    url: url
                });
            });

            const filename = 'ExampleEvent.ics'
            const file = await new Promise((resolve, reject) => {
                createEvents(events, (error, value) => {
                if (error) {
                    reject(error)
                }

                resolve(new File([value], filename, { type: 'text/calendar' }))
                })
            })

            const url = URL.createObjectURL(file);
            const anchor = document.createElement('a');
            anchor.href = url;
            anchor.download = filename;

            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);

            URL.revokeObjectURL(url);
        }
    }
}
</script>